import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {RockBottom} from "../RockBottom";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class RockBottomIntroConfig implements GameIntroViewConfig {
    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.4, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff

        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xBet: true,
        xSplit: true,
        xCap: true,
        volatility: Volatility.HIGH
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[] = [];

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("page1", "resources/images/intro_feature1.png");
        imgLoader.add("page2", "resources/images/intro_feature2.png");
        imgLoader.add("page3", "resources/images/intro_feature3.png");
        imgLoader.add("betBoost", "resources/images/intro_feature4.png"); //need to update  image
        imgLoader.add("logo", "resources/images/introLogo.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    onResize(): void {
        if (NolimitApplication.isLandscape) {
            this.logo.scale.set(1);
            this.logo.position.y = 65;
        } else {
            this.logo.scale.set(1.5);
            this.logo.position.y = 15;
        }
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5);
        this.logo.addChild(logoSprite);

        const numPages: number = 3;
        let page: SlideShowPage;
        for (let count: number = 1; count <= numPages; count++) {
            page = new SlideShowPage(ImgLoader.getImgTexture("page" + count));
            page.children[0].x = 0;
            (page.children[0] as PIXI.Sprite).anchor.set(0.5);
            if (count === 2) {
                page.children[0].y = 10;
            }

            this.pages.push(page);
        }

        if (RockBottom.apiPlugin.gameClientConfiguration.isSet) {
            if (RockBottom.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
                this.addBoostPage();
            }
        } else {
            RockBottom.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (RockBottom.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
                    this.addBoostPage();
                }
            });
        }
    }

    private addBoostPage(): void {
        const betBoostImage: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("betBoost"));
        betBoostImage.anchor.set(0.5);
        const page: SlideShowPage = new SlideShowPage();
        page.addChild(betBoostImage)
        this.pages.splice(3, 0, page);
    }
}